import { render } from "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=template&id=af46f834&scoped=true&ts=true"
import script from "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchMaterialsOnJapaneseEmigration.vue?vue&type=style&index=0&id=af46f834&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af46f834"]])

export default __exports__